import { render, staticRenderFns } from "./UniversityIndex.vue?vue&type=template&id=0b2fdc2c&scoped=true&"
import script from "./UniversityIndex.vue?vue&type=script&lang=js&"
export * from "./UniversityIndex.vue?vue&type=script&lang=js&"
import style0 from "./UniversityIndex.vue?vue&type=style&index=0&id=0b2fdc2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fdc2c",
  null
  
)

export default component.exports